//@ts-check

import { parseHtml } from 'helpers';
import React from 'react';

// @ts-ignore
import stylesCourse from 'styles/Course.module.scss';

const FillInTheGapMarking = ({ result }) => {
  return (
    <div className="whiteSpacePre foo freetext-correct-ans-align">
      <div>
        <div
          className={
            `flexRow ${stylesCourse['item-section-normal']}` +
            ` ${stylesCourse['item-section-enabled']}`
          }
          style={{
            // @ts-ignore
            '--labelcolor': '#c1c9d4',
          }}
        >
          <span className="px-md-2 px-05 py-05 customconten_elecment fill-bank-span  w-100 fill-overflow-image">
            {parseHtml(result?.modifiedContent)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FillInTheGapMarking;
